import { P2GBox } from '@parcel2go/core-ui';

export const OnboardingScreenContentWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <P2GBox textAlign="center" sx={{ minHeight: '500px' }}>
      {children}
    </P2GBox>
  );
};
